import request from 'utils/header';

// Check if user has played today
const check_user_played_today = (userId) => 
  request.post('/dice-game/check-played', { userId });

// Submit dice game result
const submit_dice_game = (userId, rolls, highestScore) => 
  request.post('/dice-game/submit', { userId, rolls, highestScore });

// Get all dice games (admin)
const get_all_dice_games = (data) => {
  return request.post('/dice-game/all', data);
};

// Get dice game statistics
const get_dice_game_stats = (company) => 
  request.post('/dice-game/stats', { company });

// Update dice game config
const update_dice_game_config = (data) => 
  request.post('/dice-game/config/update', data);

// Get dice game config
const get_dice_game_config = (company) => 
  request.post('/dice-game/config', { company });

// Mark prize as claimed
const mark_prize_claimed = (gameId) => 
  request.post('/dice-game/claim', { gameId });

const diceGameApi = {
  check_user_played_today,
  submit_dice_game,
  get_all_dice_games,
  get_dice_game_stats,
  update_dice_game_config,
  get_dice_game_config,
  mark_prize_claimed
};

export default diceGameApi;

